import {useSelector} from 'react-redux';
import getExtraData from '../extra.data';
import {createSelector} from "@reduxjs/toolkit";

const extraDataSelector =   createSelector(
  (state: any) => state.pdpItem?.details?.attributes?.typeId,
  typeId => typeId,
  typeId => getExtraData(typeId)
)

const useExtraData = () => useSelector(extraDataSelector);

export default useExtraData;
